import React, { Component } 	from 'react'
import { withRouter }           from 'react-static'
import {UAParser}               from 'ua-parser-js'
//
import Navbar       from 'components/Navbar'
import Main         from 'components/Main'
import Head         from 'components/Head'
import Lateral      from 'components/Lateral'
import LinkTop      from 'components/LinkTop'
import Footer       from 'components/Footer'

import '../app.scss'

export default withRouter(
    class wrapper extends Component {
        constructor(props){
            super(props)

            this.didScroll = false
            this.lastScrollTop = 0
            this.delta = 35
            this.navbarHeight = 80

            this.state ={
                scrolling: false,
                label: '',
                theme: ''
            }
        }

        getScrollTop =() =>{
            let st = window.scrollY

            // Make sure they scroll more than delta
            if(Math.abs(this.lastScrollTop - st) <= this.delta)
                return

            if (st > this.lastScrollTop && st > this.navbarHeight){
                // Scroll Down & not open
                this.setState({ scrolling: true })

            } else {
                // Scroll Up
                if(st + window.innerHeight < document.body.scrollHeight) {
                    this.setState({ scrolling: false })
                }
            }

            this.lastScrollTop = st
        }

        isInViewport = (elem) =>{
            var bounding = elem.getBoundingClientRect();
            return (
                bounding.top >= 0 &&
                bounding.left >= 0 &&
                bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
            )
        }

        getNavLabel =() =>{
            let label = ''
            switch(this.props.location.pathname.split('/')[1]){
                case 'about':
                    label = 'The ward'
                    break
                case 'services':
                    label = 'How we work'
                    break
                case 'news':
                    label = 'News'
                    break
                case 'contact':
                    label = 'Contact'
                    break
                case 'work':
                    if (this.props.location.pathname.split('/')[2] == 'casestudies'){
                        label = 'Case study'
                    }
                    else {
                        label = 'Our work'
                    }
                    break
                default:
                    label = 'Create change'
                    break
            }
            return label
        }

        getCurrentPage =() =>{
            let currentPage = ''
            switch (this.props.location.pathname.split('/')[1]){
                case '':
                    currentPage = 'home'
                    break
                case 'work':
                    currentPage = (this.props.location.pathname.split('/')[2])
                    break
                default:
                    currentPage = this.props.location.pathname.split('/')[1]
                    break
            }
            return currentPage
        }

        getLatLabel =() =>{
            for (let section of document.querySelectorAll('*[data-lateral]')) {
                if (this.isInViewport(section)) {
                    this.setState({ label: section.dataset.lateral, theme: section.dataset.theme ? section.dataset.theme : '' })
                    break
                }
            }
        }

        handleScroll =() =>{
            this.getScrollTop()
            this.getLatLabel()
        }

        componentDidMount() {
            return window.addEventListener('scroll', this.handleScroll, { capture: false, passive: true})
        }

        componentWillUnmount() {
            return window.removeEventListener('scroll', this.handleScroll)
        }

        render () {
            const { children } = this.props
            const page = this.getCurrentPage()
            const parser = new UAParser()
            const client = parser.getResult()

            return (
                <div className={`wrapper ${ page } ${ (client.browser.name) ? client.browser.name.toLowerCase() : '' } ${ (client.os.name) ? client.os.name.toLowerCase() : '' } ${ this.state.theme }`}>
                    <Head path={this.props.location.pathname} />
                    <Navbar
                        label={ this.getNavLabel() }
                        scrolling={ this.state.scrolling }
                    />
                    <Main>
                        <Lateral label={this.state.label} />
                        <LinkTop />

                        { children }
                    </Main>
                    <Footer />
                </div>
            )
        }
    }
)




// WEBPACK FOOTER //
// /opt/build/repo/src/components/Wrapper.js